import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LogInstanceToken } from './interfaces/log.interface';
import { LogDexieService } from './services/log/log-dexie.service';
import { LogIndexedDbService } from './services/log/log-indexed-db.service';

@NgModule({
    imports: [CommonModule],
})
export class PaceLoggingModule {
    public static forRoot(): ModuleWithProviders<PaceLoggingModule> {
        return {
            ngModule: PaceLoggingModule,
            providers: [
                LogDexieService,
                {
                    provide: LogInstanceToken,
                    useClass: LogIndexedDbService,
                },
            ],
        };
    }
}
